<p-dialog
  [(visible)]="visible"
  [modal]="modal"
  [closable]="closable"
  [style]="{ width: '400px' }"
  [showHeader]="false"
  maskStyleClass="backdrop-blur-sm"
  (visibleChange)="onCloseDialog()"
  [ngClass]="containerClass">

  <div class="flex flex-col items-center gap-6 text-center p-6">

    <!-- Icono -->
    <div class="confirmation-dialog-icon">
      <i [class]="iconClass" [ngStyle]="getIconStyle()"></i>
    </div>

    <!-- Título -->
    <div class="confirmation-dialog-title">
      {{ title }}
    </div>

    <!-- Mensaje -->
    <div class="confirmation-dialog-message text-gray-700">
      {{ message }}
    </div>

    <!-- Botones -->
    <div class="w-full grid grid-cols-2 gap-6">
      <p-button
        fluid
        [label]="confirmButtonText"
        severity="primary"
        (onClick)="onConfirmClick()"
        styleClass="flex-1"
        class="col-span-1">
      </p-button>
      
      <p-button
        fluid
        [label]="cancelButtonText"
        severity="secondary"
        (onClick)="onCancelClick()"
        styleClass="flex-1"
        class="col-span-1">
      </p-button>
    </div>

  </div>
</p-dialog>